//#region src/components/inline-reference/safe-href.ts
var e = (e) => {
	if (!e) return;
	let t = e.trim(), n = Array.from(t).filter((e) => e.charCodeAt(0) > 32 && e.charCodeAt(0) !== 127).join("");
	if (!/^[a-z][a-z\d+.-]*:/i.test(n) || /^(https?|mailto|tel):/i.test(n)) return t;
};
//#endregion
export { e as safeHref };
